import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import { SERVICE_PILLARS } from '../../data/servicePillars';
import './ServiciosPage.css';

const ServiciosPage = ({ darkMode, toggleDarkMode }) => {
  const pilares = SERVICE_PILLARS.map((pilar) => ({
    titulo: pilar.title,
    descripcion: pilar.short,
    href: pilar.href,
  }));

  const otrosServicios = [
    {
      titulo: 'Dónde trabajamos',
      descripcion:
        'Oficina en Santa Cruz de Tenerife, atención presencial en Canarias y proyectos en remoto para toda España.',
      href: '/donde-trabajamos',
    },
    {
      titulo: 'Soluciones de IA',
      descripcion:
        'Hub de la línea: cumplimiento Art. 4, agentes, IA privada y despliegue en producción. Elige la puerta; no un catálogo genérico de “IA para empresas”.',
      href: '/soluciones-ia',
    },
    {
      titulo: 'Consultoría Azure',
      descripcion:
        'Infraestructura de proyectos en Azure: entornos, accesos, costes y operación. No es 365 ni Kubernetes. Hija del pilar Microsoft.',
      href: '/servicios/azure',
    },
    {
      titulo: 'Dynamics 365 Business Central',
      descripcion:
        'Implantación de Business Central cuando el ERP tiene que vivir en Microsoft. Si Vulpin encaja mejor, te lo decimos.',
      href: '/servicios/business-central',
    },
    {
      titulo: 'Integraciones empresariales',
      descripcion:
        'APIs y conectores para contabilidad, almacenes, RRHH y más. Conectamos tus sistemas para trabajar de forma integrada.',
      slug: 'integraciones-empresariales',
    },
    {
      titulo: 'Bono IA · Plan IA360',
      descripcion:
        'Diagnóstico para definir un proyecto real de IA antes de la convocatoria anunciada: proceso, datos, alcance e indicadores.',
      slug: 'bono-ia-plan-ia360',
    },
    {
      titulo: 'Aplica Inteligencia Artificial 2026 (SPRI)',
      descripcion:
        'Landing de captación para la ayuda de SPRI con un servicio de e-commerce, portal de clientes, IA para analítica comercial e IA para presupuestos, además de proyectos a medida.',
      slug: 'aplica-inteligencia-artificial-2026',
    },
    {
      titulo: 'Cumplimiento y alfabetización IA (Art. 4)',
      descripcion:
        'Diagnóstico, formación bonificable FUNDAE y documentación lista para la AESIA.',
      href: '/cumplimiento-ia',
    },
    {
      titulo: 'IA privada / soberana',
      descripcion:
        'IA on-premise o nube privada europea integrada con Vulpin. El dato nunca sale de tu servidor.',
      href: '/ia-privada',
    },
    {
      titulo: 'Software de gestión a medida',
      descripcion:
        'Desarrollamos ERP, CRM y sistemas de gestión personalizados que se adaptan perfectamente a tu negocio.',
      slug: 'software-gestion-medida',
    },
    {
      titulo: 'Consultoría tecnológica',
      descripcion:
        'Diagnóstico digital completo y roadmap de transformación tecnológica para tu empresa.',
      slug: 'consultoria-tecnologica',
    },
    {
      titulo: 'Infraestructura cloud y DevOps',
      descripcion:
        'Alta disponibilidad, backups, contenedores y CI/CD. Infraestructura cloud robusta y escalable.',
      slug: 'infraestructura-cloud-devops',
    },
    {
      titulo: 'BI y explotación de datos',
      descripcion:
        'Haz que tus datos trabajen para ti: dashboards, análisis y Business Intelligence para tomar mejores decisiones.',
      slug: 'bi-explotacion-datos',
    },
  ];

  const renderServicioCard = (servicio, destacado = false) => (
    <div
      key={servicio.slug || servicio.href}
      className={`servicio-card${destacado ? ' destacado' : ''}`}
    >
      {destacado && <span className="servicio-pilar-badge">Principal</span>}
      <h3 className="servicio-title">{servicio.titulo}</h3>
      <p className="servicio-description">{servicio.descripcion}</p>
      <Link
        to={servicio.href || `/servicios/${servicio.slug}`}
        className="servicio-cta-button"
      >
        Ver más información
      </Link>
    </div>
  );

  return (
    <>
      <SEO 
        title="Servicios: Vulpin, Ciberseguridad, IA en producción, Web y Microsoft | E-ASY"
        description="Pilares: Vulpin Suite, ciberseguridad, IA en producción, desarrollo web, consultoría Microsoft / Azure y ingeniería a cuota (outsourcing tecnológico para pymes)."
        keywords="Vulpin Suite, ciberseguridad cumplimiento, IA en producción, desarrollo web ecommerce, consultoría Microsoft Azure, Google Workspace, E-ASY Tenerife"
        canonical="https://e-asy.es/servicios"
      />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className={`servicios-page ${darkMode ? 'dark' : 'light'}`}>
        {/* Hero Section */}
        <section className="servicios-hero">
          <div className="servicios-hero-content">
            <div className="servicios-hero-text">
              <h1 className="servicios-hero-title">Servicios de Consultoría Tecnológica</h1>
              <p className="servicios-hero-subtitle">
                Transformamos empresas con soluciones tecnológicas a medida. Desde ERP y CRM hasta automatización y desarrollo web, impulsamos tu crecimiento digital.
              </p>
              <div className="servicios-hero-stats">
                <div className="hero-stat">
                  <div className="hero-stat-number">50+</div>
                  <div className="hero-stat-label">proyectos exitosos</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">5+</div>
                  <div className="hero-stat-label">años de experiencia</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">95%</div>
                  <div className="hero-stat-label">satisfacción cliente</div>
                </div>
              </div>
            </div>
            <div className="servicios-hero-video">
              <div className="servicios-hero-visual">
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="servicios-hero-video"
                >
                  <source src="/videos/hero-servicios-v1.mp4" type="video/mp4" />
                  <source src="/videos/hero-servicios-v1.webm" type="video/webm" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </div>
            </div>
          </div>
        </section>

      {/* Servicios Grid */}
      <section className="servicios-grid-section">
        <div className="servicios-grid-content">
          <div className="servicios-grid-header">
            <h2 className="servicios-grid-title">Pilares de servicio</h2>
            <p className="servicios-grid-subtitle">
              Vulpin Suite, ciberseguridad, IA en producción, desarrollo web,
              consultoría Microsoft / Azure / Google Workspace e ingeniería a
              cuota. El resto del catálogo apoya estos pilares.
            </p>
          </div>
          <div className="servicios-grid servicios-grid-pilares">
            {pilares.map((servicio) => renderServicioCard(servicio, true))}
          </div>

          <div className="servicios-grid-header servicios-grid-header-secondary">
            <h2 className="servicios-grid-title">Más servicios</h2>
            <p className="servicios-grid-subtitle">
              Capas especializadas y programas de ayudas que complementan los pilares
            </p>
          </div>
          <div className="servicios-grid">
            {otrosServicios.map((servicio) => renderServicioCard(servicio))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="servicios-cta-section">
        <div className="servicios-cta-content">
          <h2 className="servicios-cta-title">
            ¿No encuentras lo que buscas?
          </h2>
          <p className="servicios-cta-subtitle">
            Cada empresa es única. Si no ves exactamente lo que necesitas, 
            contáctanos y crearemos una solución personalizada para ti.
          </p>
          <div className="servicios-cta-buttons">
            <Link to="/contacto" className="cta-button primary">
              Agenda una consultoría gratuita
            </Link>
            <Link to="/sectores" className="cta-button secondary">
              Ver soluciones por sector
            </Link>
          </div>
        </div>
      </section>
    </div>
    <Footer darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </>
  );
};

export default ServiciosPage; 